// Import images
import heroImage1 from '../assets/images/mmm.webp';
import heroImage2 from '../assets/images/nnn.avif';
import heroImage3 from '../assets/images/vvv.jpg';
import heroImage4 from '../assets/images/bbb.jpg';
import heroImage5 from '../assets/images/ccc.jpg';
import aboutImage from '../assets/images/fff.jpg';
import project1 from '../assets/images/kkk.jpg';
import project2 from '../assets/images/ooo.jpg';
import project3 from '../assets/images/zzz.jpg';
import project4 from '../assets/images/aaa.jpg';
import project5 from '../assets/images/tttt.webp';

// Site Configuration
export const siteConfig = {
  companyName: "Mahabali Construction",
  tagline: "Building Dreams into Reality",
  email: "info@Mahabali.com",
  phone: "+91 9420409902",
  address: "123 Construction Ave, Building City, BC 12345",
  socialMedia: {
    facebook: "https://facebook.com/mahabali",
    twitter: "https://twitter.com/mahabali",
    linkedin: "https://linkedin.com/company/mahabali",
    instagram: "https://instagram.com/mahabali"
  }
};

// Hero Slider Images
export const heroImages = [
  {
    id: 1,
    image: heroImage1,
    title: "Modern Construction Excellence",
    subtitle: "Building the Future, Today"
  },
  {
    id: 2,
    image: heroImage2,
    title: "Quality Craftsmanship",
    subtitle: "Where Innovation Meets Tradition"
  },
  {
    id: 3,
    image: heroImage3,
    title: "Trusted Construction Partner",
    subtitle: "Your Vision, Our Mission"
  },
  {
    id: 4,
    image: heroImage4,
    title: "Sustainable Building Solutions",
    subtitle: "Eco-Friendly & Future-Ready"
  },
  {
    id: 5,
    image: heroImage5,
    title: "Professional Construction Services",
    subtitle: "Excellence in Every Detail"
  }
];

// About Section Data
export const aboutData = {
  image: aboutImage,
  title: "About Mahabali Constructions",
  description: "Mahabali Constructions is a modern construction company driven by quality, safety, and innovation. We specialize in residential, commercial, and interior projects, delivering reliable solutions backed by experienced engineers, architects, and skilled builders.",
  missionStatement: "Our mission is to transform visions into reality through innovative construction practices, sustainable building methods, and unwavering commitment to quality.",
  yearsOfExperience: "15+",
  projectsCompleted: "500+",
  satisfiedClients: "450+"
};

// Core Values
export const coreValues = [
  {
    id: 1,
    title: "Quality",
    description: "We maintain the highest standards in materials, workmanship, and execution.",
    icon: "⭐"
  },
  {
    id: 2,
    title: "Integrity",
    description: "Transparent communication and ethical practices guide every project.",
    icon: "🤝"
  },
  {
    id: 3,
    title: "Innovation",
    description: "We apply modern techniques and smart designs to build future-ready spaces.",
    icon: "💡"
  },
  {
    id: 4,
    title: "Safety",
    description: "Safety is our top priority on every construction site and project.",
    icon: "🛡️"
  }
];

// Services Data
export const services = [
  {
    id: 1,
    title: "Floor Plan Design",
    description:
      "Professional floor planning solutions to optimize space and functionality.",
    features: [
      "Accurate Room Measurements",
      "Smart Space Utilization",
      "Modern Layout Concepts",
      "Optimized Ventilation",
      "Future Expansion Planning"
    ],
    icon: "📐"
  },
  {
    id: 2,
    title: "2D Layout Design",
    description:
      "Detailed 2D technical drawings for precise construction planning.",
    features: [
      "Technical Dimension Drawings",
      "Clear Structural Layouts",
      "Electrical Planning",
      "Plumbing Planning",
      "Approval Ready Documentation"
    ],
    icon: "📏"
  },
  {
    id: 3,
    title: "3D Elevation & Visualization",
    description:
      "Realistic 3D exterior elevation designs for stunning project presentation.",
    features: [
      "Modern Facade Design",
      "Material Visualization",
      "Lighting Effects",
      "High Quality Rendering",
      "Client Presentation Ready"
    ],
    icon: "🏢"
  },
  {
    id: 4,
    title: "3D Walkthrough & Virtual Visualization",
    description:
      "Interactive 3D walkthrough experiences for interior and exterior previews.",
    features: [
      "Virtual Tours",
      "Interior Walkthrough",
      "Exterior Walkthrough",
      "HD Rendering",
      "Client Friendly Preview"
    ],
    icon: "🎥"
  },
  {
    id: 5,
    title: "Interior Space Planning",
    description:
      "Efficient and aesthetic interior planning solutions for modern spaces.",
    features: [
      "Furniture Layout",
      "Lighting Planning",
      "Space Optimization",
      "Modern Styling",
      "Functional Design"
    ],
    icon: "🛋️"
  }
];

// Projects/Portfolio Data
export const projects = [
  {
    id: 1,
    title: "Luxury Residential Villa",
    category: "Residential",
    location: "Beverly Hills, CA",
    image: project1,
    description: "5,000 sq ft luxury villa with modern amenities and sustainable design",
    completionDate: "2024",
    client: "Private Client",
    features: ["Smart Home Technology", "Solar Panels", "Infinity Pool", "Home Theater"]
  },
  {
    id: 2,
    title: "Corporate Office Complex",
    category: "Commercial",
    location: "Downtown LA",
    image: project2,
    description: "15-story modern office building with LEED Gold certification",
    completionDate: "2023",
    client: "TechCorp Inc.",
    features: ["LEED Certified", "Green Building", "Modern Workspace", "Parking Structure"]
  },
  {
    id: 3,
    title: "Urban Shopping Center",
    category: "Commercial",
    location: "San Francisco, CA",
    image: project3,
    description: "75,000 sq ft retail and entertainment complex in prime location",
    completionDate: "2024",
    client: "Retail Ventures LLC",
    features: ["Multi-level Design", "Food Court", "Entertainment Zone", "Underground Parking"]
  },
  {
    id: 4,
    title: "Modern Apartment Complex",
    category: "Residential",
    location: "Seattle, WA",
    image: project4,
    description: "120-unit luxury apartment building with rooftop amenities",
    completionDate: "2023",
    client: "Urban Living Group",
    features: ["Rooftop Garden", "Fitness Center", "Co-working Spaces", "Pet Facilities"]
  },
  {
    id: 5,
    title: "Industrial Warehouse",
    category: "Industrial",
    location: "Portland, OR",
    image: project5,
    description: "100,000 sq ft distribution center with advanced logistics",
    completionDate: "2024",
    client: "LogiTech Solutions",
    features: ["High Ceiling", "Loading Docks", "Climate Control", "Security Systems"]
  }
];

// Testimonials Data
export const testimonials = [
  {
    id: 1,
    name: "John Anderson",
    position: "Homeowner",
    company: "Private Client",
    rating: 5,
    text: "Mahabali transformed our vision into reality. Their attention to detail and professionalism exceeded our expectations. Our dream home is now a beautiful reality!",
    image: null
  },
  {
    id: 2,
    name: "Sarah Mitchell",
    position: "CEO",
    company: "TechStart Inc.",
    rating: 5,
    text: "Working with Mahabali on our office complex was seamless. They delivered on time, within budget, and the quality is outstanding. Highly recommend!",
    image: null
  },
  {
    id: 3,
    name: "Michael Chen",
    position: "Property Developer",
    company: "Urban Spaces",
    rating: 5,
    text: "Mahabali has been our go-to construction partner for 5 years. Their expertise, reliability, and quality workmanship are unmatched in the industry.",
    image: null
  },
  {
    id: 4,
    name: "Emily Rodriguez",
    position: "Business Owner",
    company: "Cafe Dreams",
    rating: 5,
    text: "The renovation of our cafe was handled perfectly. Mahabali understood our vision and delivered a space that's both beautiful and functional.",
    image: null
  }
];

// FAQ Data
export const faqs = [
  {
    id: 1,
    question: "What types of construction projects do you handle?",
    answer: "We handle residential, commercial, industrial, and institutional projects including new construction, renovations, remodeling, and interior design services."
  },
  {
    id: 2,
    question: "How long does a typical project take?",
    answer: "Project timelines vary based on scope and complexity. Residential projects typically take 3-8 months, while commercial projects may take 6-18 months. We provide detailed timelines during consultation."
  },
  {
    id: 3,
    question: "Do you provide design services?",
    answer: "Yes! We offer comprehensive design services including architectural design, interior design, and space planning. Our in-house team works closely with you to bring your vision to life."
  },
  {
    id: 4,
    question: "What is your payment structure?",
    answer: "We typically work with a milestone-based payment structure with an initial deposit, progress payments, and final payment upon completion. We'll provide a detailed payment schedule during project planning."
  },
  {
    id: 5,
    question: "Are you licensed and insured?",
    answer: "Absolutely! We are fully licensed, bonded, and insured. We carry comprehensive liability insurance and workers' compensation coverage for all our projects."
  },
  {
    id: 6,
    question: "Do you offer warranties on your work?",
    answer: "Yes, we provide warranties on both workmanship and materials. Specific warranty terms are detailed in the project contract and vary based on the scope of work."
  }
];

// Stats/Achievements
export const stats = [
  {
    id: 1,
    number: "15+",
    label: "Years Experience",
    icon: "📅"
  },
  {
    id: 2,
    number: "500+",
    label: "Projects Completed",
    icon: "🏗️"
  },
  {
    id: 3,
    number: "450+",
    label: "Happy Clients",
    icon: "😊"
  },
  {
    id: 4,
    number: "50+",
    label: "Expert Team Members",
    icon: "👷"
  }
];

// Team Members
export const teamMembers = [
  {
    id: 1,
    name: "Suresh Deshmukh",
    position: "Chief Executive Officer",
    specialty: "Strategic Leadership",
    bio: "20+ years of construction industry experience",
    image: null
  },
  {
    id: 2,
    name: "Priyanka Kulkarni",
    position: "Chief Operating Officer",
    specialty: "Operations Management",
    bio: "Expert in project delivery and quality control",
    image: null
  },
  {
    id: 3,
    name: "Swapnil Joshi",
    position: "Lead Architect",
    specialty: "Architectural Design",
    bio: "Award-winning architect with sustainable design focus",
    image: null
  },
  {
    id: 4,
    name: "Neha Patil",
    position: "Project Manager",
    specialty: "Commercial & Residential Projects",
    bio: "15+ years managing large-scale construction projects",
    image: null
  }
];

// Contact Form Fields
export const contactFormFields = [
  { name: 'name', type: 'text', label: 'Full Name', required: true },
  { name: 'email', type: 'email', label: 'Email Address', required: true },
  { name: 'phone', type: 'tel', label: 'Phone Number', required: true },
  { name: 'projectType', type: 'select', label: 'Project Type', required: true,
    options: ['Residential', 'Commercial', 'Industrial', 'Renovation', 'Consultation']
  },
  { name: 'budget', type: 'select', label: 'Budget Range', required: false,
    options: ['Under $50K', '$50K - $100K', '$100K - $250K', '$250K - $500K', '$500K+']
  },
  { name: 'message', type: 'textarea', label: 'Project Details', required: true }
];